<template>
  <button class="button" :class="{
    button_animated: animation,
    button_light: light,
    button_outlined: outlined,
    button_secondary: secondary,
    button_primary: primary,
    button_small: small,
  }" v-bind="$attrs" @click="$emit('click', $event)">
    <slot />
  </button>
</template>

<script>
export default {
  name: "Button",

  props: ["animation", "light", "outlined", "secondary", "small", "primary"],
}
</script>

<style lang="sass">
@import '../sass/variables'

$bg: rgba(85, 181, 166, 1)
$bg-hover: lighten($bg, 5%)
$bg-active: darken($bg, 5%)

$bg-primary: rgba(192, 60, 80, 1)
$bg-primary-hover: lighten($bg-primary, 5%)
$bg-primary-active: darken($bg-primary, 5%)

$bg-secondary: rgba(236, 89, 41, 1)
$bg-secondary-hover: rgba(209, 59, 10, 1)
$bg-secondary-active: rgba(209, 59, 10, 1)
$text-color: rgba(255, 255, 255, 1)
$radius: 14px

@keyframes button-pulse
  0%
    opacity: 1
    transform: scale(1,1)

  50%
    opacity: 0.4

  100%
    opacity: 0
    transform: scale(2.5,3)

.button
  display: flex
  justify-content: center
  align-items: center
  position: relative
  gap: 4px
  border-radius: $radius
  padding: 20px 48px
  width: 100%
  color: $text-color
  background: $bg
  min-width: unset
  font-weight: 500
  font-size: 18px
  line-height: 22px
  transition: .3s ease
  text-decoration: none
  z-index: 1

  @media screen and (min-width: $lg)
    width: fit-content

  &:disabled
    opacity: .3
    pointer-events: none

    &:before
      content: none!important

  &:hover
    background: $bg-hover
    &.button_animated
      &::before
        background: $bg-hover

  &:active
    background: $bg-active
    &.button_animated
      &::before
        background: $bg-active

  &.button_outlined
    background: none
    border: 1px solid $bg
    color: $bg
    animation: none

    &:hover
      background: $bg-active
      color: $text-color

  &.button_animated
    &::before
      content: ""
      position: absolute
      border-radius: $radius
      width: 50%
      height: 50%
      transform: scale(1,1)
      background: $bg
      animation: button-pulse 1.5s infinite
      z-index: -1
      transition: .3s ease
      pointer-events: none

  &.button_secondary
    color: #ffffff
    background: $bg-secondary
    min-height: 56px
    padding: 12px 32px

    &:before
      background: $bg-secondary

    &:hover
      background: $bg-secondary-hover

      &::before
        background: $bg-secondary-hover

    &:active
      background: $bg-secondary-active

      &::before
        background: $bg-secondary-active

  &.button_light
    background: $text-color
    color: rgba(42, 42, 42, 1)

    &.button_animated
      &::before
        background: $text-color

    &:hover
      background: darken($text-color, 2%)
      &.button_animated
        &::before
          background: darken($text-color, 2%)

    &:active
      background: darken($text-color, 5%)
      &.button_animated
        &::before
          background: darken($text-color, 5%)

  &.button_small
    min-height: 40px
    padding: 8px 32px
</style>
